export const STUDENT_COLOR = "#2a78d6";
export const STUDENT_COLOR_OUTSIDE_SCORE_WINDOW = "#b7d3f6";
export const COORDINATOR_COLOR = "#eb6834";
export const COORDINATOR_REVIEW_PERIOD_COLOR = "#f5c0aa";
